const store = {
  state: {
    score: 0,
    result: '',
    badges: [],
    nome: '',
    popup: false
  }
}
store.addBadge = item => {
  store.state.badges.push(item)
}
store.addScore = score => {
  store.state.score += score || 0
  return store.state.score
}
store.setResult = result => {
  store.state.result = result
}
store.setPopup = (popup) => {
  store.state.popup = popup
}
export default store



// WEBPACK FOOTER //
// ./src/store/AppStore.js